"use client";
import { useProps } from "../../core/MantineProvider/use-props/use-props.mjs";
import { factory } from "../../core/factory/factory.mjs";
import { ModalBaseBody } from "../ModalBase/ModalBaseBody.mjs";
import { useModalContext } from "./Modal.context.mjs";
import Modal_module_default from "./Modal.module.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Modal/ModalBody.tsx
const ModalBody = factory((_props) => {
	const { classNames, className, style, styles, vars, ...others } = useProps("ModalBody", null, _props);
	return /* @__PURE__ */ jsx(ModalBaseBody, {
		...useModalContext().getStyles("body", {
			classNames,
			style,
			styles,
			className
		}),
		...others
	});
});
ModalBody.classes = Modal_module_default;
ModalBody.displayName = "@mantine/core/ModalBody";
//#endregion
export { ModalBody };

//# sourceMappingURL=ModalBody.mjs.map